/*! Goldtop - ADD button on "Pairs well with" cards, mobile only.
    Loaded from snippets/product-complementary.liquid alongside the swatch row
    and the carousel. Read those files first; this one sits on top of both.

    Joe, 26 Sep: "On mobile, add a small 'add to cart' button to the pairs well
    with products below the colour selector etc. It only needs to say 'ADD' and
    not 'ADD TO CART'. When clicked, if there are variables to be selected
    (size / style etc) there should open up a slider from the bottom in order to
    make the choices."

    ==================================================================
    THIS FILE NO LONGER OWNS A SHEET.

    It used to carry one: its own markup, its own stylesheet, its own open and
    close, and - because none of that was shared - none of the four freezes
    found and fixed in the slide cart's sheet. All four were still here when
    this was first rewritten on 28 Sep, and every one had to be diagnosed
    twice.

    The sheet now lives in assets/gt-sheet.js, which theme.liquid loads on every
    page, and three surfaces call it. Read that file's header for what the sheet
    does and why: the generation guard, the timer that races the frames, the
    scrim that stops hit-testing, and clearBottomChrome. A fix there lands
    everywhere.

    What is left here is the only thing that was ever specific to this surface:
    getting a button onto a recommendation card, and knowing which product the
    card is pointing at.

    ==================================================================
    WHERE THE BUTTON GOES, AND WHY THAT IS AWKWARD.

    A recommendation card on mobile is:

      div.grid-product
        div.grid-product__content
          div.grid__item-image-wrapper
            div.grid-product__image-mask          the thumbnail
            a.grid-product__link                  <- wraps everything below
              div.grid-product__meta
                div.grid-product__title
                div.grid-product__price
                div.gt-rec-swatches               the colour swatches
                span.shopify-product-reviews-badge

    The button belongs under the swatches, which means putting a <button>
    inside an <a>. That is invalid HTML and, worse, the anchor carries a
    ::after overlay at inset 0 that eats every click on the card - the exact
    trap that cost us an afternoon when the swatch row first shipped and only
    scripted clicks worked while real taps navigated.

    The fix is the one already proven on this same card: the control is lifted
    above the overlay in CSS (position:relative, z-index:2) and its handler runs
    in the CAPTURE phase with preventDefault and stopPropagation, so the anchor
    never sees the event. Anything less and tapping ADD opens the product page.

    ==================================================================
    AVAILABILITY COMES FROM THE STOREFRONT, NOT THE ADMIN API.

    /products/<handle>.js is the storefront's own answer and already accounts
    for which locations this sales channel sells from. The Admin API does not:
    on the Neck Tube it reported four in stock while /cart/add.js returned 422
    "already sold out".

    ==================================================================
    ONE VARIANT ADDS STRAIGHT AWAY.

    A sheet with nothing to choose in it is a worse experience than no sheet.
    It still needs somewhere to report a failure, so on failure the sheet opens
    carrying the message and the shopper can try again from there.
*/
(function () {
  if (window.__gtRecAdd) return;
  window.__gtRecAdd = true;

  var MQ = window.matchMedia("(max-width: 768px)");
  var CONFIRM_TIMEOUT = 12000;
  var cache = {};
  var busy = false;

  function q(s, r) { try { return (r || document).querySelector(s); } catch (e) { return null; } }
  function qa(s, r) { try { return [].slice.call((r || document).querySelectorAll(s)); } catch (e) { return []; } }

  function sheet() { return window.GTSheet; }

  function product(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var pr = fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { cache[handle] = j; return j; })
      .catch(function () { cache[handle] = null; return null; });
    cache[handle] = pr;
    return pr;
  }

  function cardInfo(card) {
    var a = q("a.grid-product__link", card) || q("a[href*='/products/']", card);
    var href = a ? (a.getAttribute("href") || "") : "";
    var h = href.match(/\/products\/([^/?#]+)/);
    var v = href.match(/[?&]variant=(\d+)/);
    return { handle: h ? h[1] : null, variantId: v ? Number(v[1]) : 0 };
  }

  function openFor(p, startId, failed) {
    var s = sheet();
    if (!s) return false;
    return s.open({ product: p, startId: startId, failed: failed,
                    confirmLabel: "ADD TO CART", afterAdd: "open" });
  }

  function addOnly(p, v) {
    var s = sheet();
    if (!s) return;
    busy = true;
    var settled = false;
    function end() { if (settled) return; settled = true; clearTimeout(bail); busy = false; }
    var bail = setTimeout(function () {
      end();
      openFor(p, v.id, "That is taking longer than it should. Please check your cart before trying again.");
    }, CONFIRM_TIMEOUT);

    s.addToCart(v.id, 1)
      .then(function () { end(); s.showCart(); })
      .catch(function () {
        if (settled) return;
        end();
        delete cache[p.handle];
        openFor(p, v.id, "We could not add that just now. Nothing has been added to your cart.");
      });
  }

  function onAdd(card, btn) {
    if (busy) return;
    var info = cardInfo(card);
    if (!info.handle) return;
    btn.classList.add("is-busy");
    product(info.handle).then(function (p) {
      btn.classList.remove("is-busy");
      if (!p || !p.variants || !p.variants.length) return;
      if (p.variants.length === 1) {
        var only = p.variants[0];
        if (!only.available) return;
        addOnly(p, only);
        return;
      }
      openFor(p, info.variantId);
    });
  }

  function build(card) {
    if (!MQ.matches) return;
    var meta = q(".grid-product__meta", card);
    if (!meta) return;
    if (q(".gt-rec-add", meta)) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "gt-rec-add";
    btn.setAttribute("data-gt-rec-add", "");
    btn.textContent = "ADD";

    /* Under the swatches when there are any, under the price when there are
       not - a single-colour product has no swatch row at all. */
    var after = q(".gt-rec-swatches", meta) || q(".grid-product__price", meta);
    if (after && after.nextSibling) meta.insertBefore(btn, after.nextSibling);
    else if (after) meta.appendChild(btn);
    else meta.appendChild(btn);
  }

  function hosts() {
    return qa("product-recommendations, .product-recommendations, .product-single__related");
  }

  function sweep() {
    if (!MQ.matches) return;
    hosts().forEach(function (h) { qa(".grid-product", h).forEach(build); });
  }

  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(sweep, 60); }

  /* NARROWED, DELIBERATELY. This used to watch document.body subtree for
     childList, which on a PDP means every cart re-render, every lazy image
     swap and every app the shop loads re-ran the sweep. The only thing that
     replaces these cards is the recommendations section fetching itself. */
  function watch() {
    if (!window.MutationObserver) return 0;
    var found = 0;
    hosts().forEach(function (h) {
      if (h.__gtRecObserved) return;
      h.__gtRecObserved = true;
      found++;
      new MutationObserver(soon).observe(h, { childList: true, subtree: true });
    });
    return found;
  }

  function start() {
    /* CAPTURE PHASE. The card is one big anchor with an overlay; by the time an
       event reaches the bubble phase the navigation is already decided. */
    document.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest ? e.target.closest("[data-gt-rec-add]") : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var card = btn.closest(".grid-product");
      if (card) onAdd(card, btn);
    }, true);

    sweep();
    watch();

    /* The section mounts late on some pages, so the arrival of the host is
       watched for once and then that observer is dropped. */
    if (window.MutationObserver && !hosts().length) {
      var mo = new MutationObserver(function () {
        if (watch()) { mo.disconnect(); soon(); }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 15000);
    }

    [400, 1200, 2500].forEach(function (d) { setTimeout(function () { watch(); sweep(); }, d); });
    if (MQ.addEventListener) MQ.addEventListener("change", soon);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
